import { createFileRoute } from '@tanstack/react-router'
import { createStore, Provider } from 'jotai'
import z from 'zod'

import KetenagaanPenyuluhanPage from '@/components/pages/guest/_search/containers/ktg-penyuluhan-page'

export const Route = createFileRoute(
  '/_guest/guest/search/ktg-extensions-institutions'
)({
  component: RouteComponent,
  validateSearch: z.object({
    search: z.string().optional(),
    type_id: z.string().optional(),
    page: z.number().min(1).optional().default(1),
    per_page: z.number().min(10).max(100).optional().default(50)
  })
})

const store = createStore()

function RouteComponent() {
  return (
    <Provider store={store}>
      <KetenagaanPenyuluhanPage />
    </Provider>
  )
}
